import { cn } from '@insta-club/utilities';
import { IconProps } from './icons-props';

const LoadingIcon = ({ className, width = 15, height = 16 }: IconProps) => {
    return (
        <svg
            width={width}
            height={height}
            className={cn('animate-spin', className)}
            aria-label='Loading...'
            viewBox='0 0 100 100'
        >
            <rect
                fill='currentColor'
                height='8'
                opacity='0.075'
                rx='5'
                ry='5'
                transform='rotate(-90 50 50)'
                width='20'
                x='72'
                y='47'
                id='rect3793'
            />
            <rect
                fill='currentColor'
                height='8'
                opacity='0.083'
                rx='5'
                ry='5'
                transform='rotate(-60 50 50)'
                width='20'
                x='72'
                y='47'
                id='rect3795'
            />
            <rect
                fill='currentColor'
                height='8'
                opacity='0.16'
                rx='5'
                ry='5'
                transform='rotate(-30 50 50)'
                width='20'
                x='72'
                y='47'
                id='rect3797'
            />
            <rect
                fill='currentColor'
                height='8'
                opacity='0.25'
                rx='5'
                ry='5'
                transform='rotate(0 50 50)'
                width='20'
                x='72'
                y='47'
                id='rect3799'
            />
            <rect
                fill='currentColor'
                height='8'
                opacity='0.33'
                rx='5'
                ry='5'
                transform='rotate(30 50 50)'
                width='20'
                x='72'
                y='47'
                id='rect3801'
            />
            <rect
                fill='currentColor'
                height='8'
                opacity='0.41'
                rx='5'
                ry='5'
                transform='rotate(60 50 50)'
                width='20'
                x='72'
                y='47'
                id='rect3803'
            />
            <rect
                fill='currentColor'
                height='8'
                opacity='0.5'
                rx='5'
                ry='5'
                transform='rotate(90 50 50)'
                width='20'
                x='72'
                y='47'
                id='rect3805'
            />
            <rect
                fill='currentColor'
                height='8'
                opacity='0.58'
                rx='5'
                ry='5'
                transform='rotate(120 50 50)'
                width='20'
                x='72'
                y='47'
                id='rect3807'
            />
            <rect
                fill='currentColor'
                height='8'
                opacity='0.66'
                rx='5'
                ry='5'
                transform='rotate(150 50 50)'
                width='20'
                x='72'
                y='47'
                id='rect3809'
            />
            <rect
                fill='currentColor'
                height='8'
                opacity='0.75'
                rx='5'
                ry='5'
                transform='rotate(180 50 50)'
                width='20'
                x='72'
                y='47'
                id='rect3811'
            />
            <rect
                fill='currentColor'
                height='8'
                opacity='0.83'
                rx='5'
                ry='5'
                transform='rotate(210 50 50)'
                width='20'
                x='72'
                y='47'
                id='rect3813'
            />
            <rect
                fill='currentColor'
                height='8'
                opacity='0.91'
                rx='5'
                ry='5'
                transform='rotate(240 50 50)'
                width='20'
                x='72'
                y='47'
                id='rect3815'
            />
        </svg>
    );
};

export default LoadingIcon;

